import React from 'react';
import { Cell } from 'react-table';

import { getEstimatedLossLabel } from '@trqk/utils';

interface EstimatedLossCellProps {
    cell: Cell<TrqkGapChannel, GapChannelEstimatedLossCellValue>;
}

/**
 * Displays a range of estimated loss values, like `$1 - $5K`, using getEstimatedLossLabel to
 * handle edge cases.
 * @param props - {@link EstimatedLossCellProps}
 */
export function EstimatedLossCell({
    cell,
}: EstimatedLossCellProps): JSX.Element | null {
    const {
        value: { estimatedLossMax, estimatedLossMin },
    } = cell;

    const label = getEstimatedLossLabel({
        max: estimatedLossMax,
        min: estimatedLossMin,
    });

    if (label === null) {
        return null;
    }

    return <div className="flex items-center">{label}</div>;
}
